"use strict";
/**
 * Shared auth error message constants used by both backend (protectedProcedure)
 * and frontend (authRetryLink) for type-safe error classification.
 *
 * Backend sets these as TRPCError messages; frontend checks them to decide
 * whether to retry (transient) or sign out (terminal).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TERMINAL_AUTH_ERRORS = exports.AUTH_ERROR = void 0;
exports.AUTH_ERROR = {
    /** User's Firebase account was deleted — terminal, client must sign out */
    USER_DELETED: 'auth.error.user.deleted',
    /** User's Firebase account was disabled — terminal, client must sign out */
    USER_DISABLED: 'auth.error.user.disabled',
    /** Firebase ID token expired — transient, client should refresh and retry */
    TOKEN_EXPIRED: 'auth.error.token.expired',
    /** Firebase ID token revoked — transient, client should refresh and retry */
    TOKEN_REVOKED: 'auth.error.token.revoked',
    /**
     * Firebase ID token malformed/invalid (e.g. no "kid" claim, a custom token,
     * or a token from the wrong project) — Firebase reports `auth/argument-error`.
     * Transient: the client should force-refresh the token and retry once.
     * Not captured to Sentry — the clean 401 is the expected outcome (STE-67).
     */
    TOKEN_INVALID: 'auth.error.token.invalid',
    /** Unknown/unexpected auth error — captured to Sentry for investigation */
    UNKNOWN: 'auth.error.unknown',
};
/** Terminal auth errors where the user account no longer exists or is disabled */
exports.TERMINAL_AUTH_ERRORS = new Set([
    exports.AUTH_ERROR.USER_DELETED,
    exports.AUTH_ERROR.USER_DISABLED,
]);
//# sourceMappingURL=auth.js.map